import { render, staticRenderFns } from "./Shopping.vue?vue&type=template&id=b127f252&scoped=true&"
import script from "./Shopping.vue?vue&type=script&lang=js&"
export * from "./Shopping.vue?vue&type=script&lang=js&"
import style0 from "./Shopping.vue?vue&type=style&index=0&id=b127f252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b127f252",
  null
  
)

export default component.exports